import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import FixedContainer from '../Page/FixedContainer';
import GradientWrapper from '../GradientBox/GradientWrapper';
import Div from '../Page/Div';
import PointerText from '../UI/PointerText';
import StatsGrid from '../UI/StatsGrid';
import { isMobileWidth, MOBILE_SAFE_RESIZE } from '../globalUtils';
import { sanitize } from '../../utils';
const backgroundAnimationQueryElement = '.product-background-animation canvas';
const ProductDetailsSection = ({ content, idx, allowOpen, }) => {
    const data = content?.product_details;
    const { title, details, elements, stats_columns, stats, radius_multiplier } = data;
    let contentArray = [];
    let mobileArray = [];
    const [mobileView, setMobileView] = useState(isMobileWidth());
    const mobileViewRef = useRef(mobileView);
    mobileViewRef.current = mobileView;
    const [_, setRender] = useState(0);
    useEffect(() => {
        window.addEventListener(MOBILE_SAFE_RESIZE, onResize);
        onResize();
        return () => {
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResize);
        };
    }, []);
    const onResize = () => {
        const mobile = isMobileWidth();
        if (mobile && !mobileViewRef.current) {
            setMobileView(true);
        }
        if (!mobile && mobileViewRef.current) {
            setMobileView(false);
        }
        requestAnimationFrame(() => setRender((x) => x + 1));
    };
    if (title || details) {
        contentArray = [
            _jsxs(Div, { blocked: true, className: "product-details-title-wrapper", children: [title ? (_jsxs("div", { className: "product-details-title", children: [_jsx(GradientWrapper, { active: allowOpen }), _jsx("span", { dangerouslySetInnerHTML: {
                                    __html: sanitize(title),
                                } })] })) : null, details ? (_jsxs("div", { className: "product-details-sub-title", children: [_jsx(GradientWrapper, { active: allowOpen }), _jsx("span", { dangerouslySetInnerHTML: {
                                    __html: sanitize(details),
                                } })] })) : null] }, "title"),
        ];
    }
    const pointerElements = elements.map((element) => (_createElement(PointerText, { ...element, key: element.text + element.position, allowOpen: allowOpen, mobileVersion: mobileView, centerQuery: backgroundAnimationQueryElement, radius_multiplier: radius_multiplier })));
    if (mobileView) {
        mobileArray = [...mobileArray, ...pointerElements];
    }
    else {
        contentArray = [...contentArray, ...pointerElements];
    }
    let statsElement = null;
    if (stats_columns && stats) {
        statsElement = (_jsx(StatsGrid, { className: "product-details-stats alt-font", columns: stats_columns, rows: stats, allowOpen: allowOpen }, "stats"));
        if (!mobileView) {
            contentArray = [...contentArray, statsElement];
        }
    }
    return (_jsxs(FixedContainer, { idx: idx, allowOpen: allowOpen, parentClassName: "pointer-text-wrapper", sliderClassName: "pointer-text-slider", elementClassName: "pointer-text-element", extraRevealDelay: mobileView ? 0 : 0.7, openDelay: 0, children: [allowOpen ? contentArray : [], mobileView && (_jsxs(_Fragment, { children: [_jsx("div", { className: `pointer-text-mobile-container${!title && !details ? ' text-only' : ''}`, children: mobileArray }), statsElement] }))] }));
};
export default ProductDetailsSection;
